import { stringShortener } from '@monoimin/utils/formatters';

import type { StrapiEstate } from '@monoimin/sb-types';

export const createMetaDescriptionForProperty = (property: StrapiEstate) => {
  if (property.description) {
    const text = property.description.replace(/<[^>]+>/g, '');

    return stringShortener(text, 320);
  }

  return '';
};

export default createMetaDescriptionForProperty;
